import Icon from '../../components/Icon.vue'

Icon.register({"brands/pied-piper-hat":{"width":640,"height":512,"paths":[{"d":"M640 24.9C559.2 78.5 550.6 117.4 543.6 129.3 536.9 141.5 531.9 189.6 520.3 212.9 508.6 236.5 466.1 255.1 454.2 262.9 442.5 270.7 425.9 301 412.3 327.1 304.2 322.7 244.9 365.9 153.1 420.7 182.5 411 196.4 404 196.4 404 290.6 368 335.7 335.7 477.5 354.8 478.6 354.8 479.4 355.4 480.3 355.6 484.2 357.8 485.6 362.5 483.4 366.4L429.5 462.2C427 466.9 421.7 469.4 416.4 468.3 289.6 444.5 189.5 485.6 97.5 486.9 24.1 488 0 453.4 0 451.8 0 450.7 0.6 450.1 1.7 450.1 1.7 450.1 40 450.1 104.8 434.8 178.4 294.5 244 245.4 315.4 245.4 315.4 245.4 387.1 245.4 406 307.3 428.8 267.6 434.3 258.1 434.3 258.1 439.6 248.7 469.3 180.9 520.7 116.7 572.2 52.7 611.1 36.8 640 24.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pied-piper-hat.js
// module id = 94HG
// module chunks = 0